import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Loader } from 'components';
import { OutlinedInput } from '@material-ui/core';
import { signIn } from 'store/account';
import {
  useReduxDispatch,
  useReduxSelector
} from 'store/hooks';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  title: {
    margin: '25px 0px'
  },
  inputContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '0px 6px',
    margin: '10px 20px'
  },
  input: {
    flexGrow: 2,
    color: '#000000',
    backgroundColor: '#ffffff',
    '&:before': {
      borderBottom: '1px solid rgba(255, 255, 255, 0.6)'
    },
    '&:after': {
      borderBottom: '1px solid #0073d1'
    },
    '&:hover:not(.MuiInput-disabled-47):not(.MuiInput-focused-46):not(.MuiInput-error-49):before': {
      borderBottom: '1px solid rgba(255, 255, 255)'
    }
  },
  submit: {
    width: '100%',
    borderRadius: 5,
    color: '#ffffff',
    backgroundColor: '#027EDD',
    '&:hover': {
      backgroundColor: '#17a496'
    }
  },
  helperText: {
    '&:first-letter': {
      textTransform: 'capitalize'
    }
  },
  forgotPassword: {
    textAlign: 'right',
    fontSize: 12,
    margin: '8px 0px',
    color: '#083253',
    cursor: 'pointer'
  },
  submitContainer: {
    marginTop: 50,
    width: '100%',
    textAlign: 'center'
  },
  signUp: {
    fontSize: 12,
    marginTop: 15,
    display: 'flex',
    justifyContent: 'center'
  },
  textSignUp: {
    color: '#1ab7a7',
    fontSize: 12,
    marginLeft: 5,
    cursor: 'pointer'
  },
  iconContainer: {
    width: 79,
    height: 79,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px 0px 50px'
  },
  alertRoot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  }
}))

const SignIn = () => {
  const classes = useStyles();
  const app = useSelector(state => state.app);
  const account = useReduxSelector(state => state.account);
  const callSignIn = useReduxDispatch(signIn);

  const [form, setForm] = useState({
    username: '',
    password: ''
  })
  const [error, setError] = useState({
    username: null,
    password: null
  })

  const handleChange = (name, value) => {
    setForm({ ...form, [name]: value });
    setError({ ...error, [name]: null })
  }

  const handleChangeInput = name => event => {
    handleChange(name, event.target.value);
  }

  const onSubmit = (event) => {
    event.preventDefault();

    const unsetAttribute = [];
    const tempError = {};
    if (form.username === '') {
      tempError.username = true;
      unsetAttribute.push('Username');
    }
    if (form.password === '') {
      tempError.password = true;
      unsetAttribute.push('Password');
    }
    if (!tempError.username && !tempError.password) {
      const { username, password } = form;
      const email = `${username.replace(app.env.mailDomain, '')}${app.env.mailDomain}`
      callSignIn({ email, password })
    } else {
      setError(tempError);
    }
  }

  const getHelperText = () => {
    const errorKey = Object.keys(error).reduce((acc, key) => error[key] ? [...acc, key] : acc, []);
    return (account.hasSignInError && account.error) || (
      errorKey.length > 0 && errorKey.join(' and ') + ' is required');
  }

  return (
    <form className={classes.form}>
      <Typography className={classes.title}>Welcome, please <b>Sign In</b></Typography>
      <div className={classes.inputContainer}>
        <OutlinedInput
          id="username"
          name="username"
          placeholder="Username"
          value={form.username}
          onChange={handleChangeInput('username')}
          className={classes.input}
          inputProps={{
            style: { padding: 13, height: 10 }
          }}
          error={error.username}
        />
      </div>
      <div className={classes.inputContainer}>
        <OutlinedInput
          id="password"
          name="password"
          placeholder="Password"
          type="password"
          value={form.password}
          onChange={handleChangeInput('password')}
          className={classes.input}
          inputProps={{
            style: { padding: 13, height: 10 }
          }}
          error={error.password}
        />
      </div>
      <div className={classes.submitContainer}>
        {account.isSignInFetching
          ? <Loader />
          : <>
            <Button className={classes.submit} type="submit" onClick={onSubmit}>
              Login
            </Button>
            <Typography
              variant='caption'
              color='error'
              align='center'
              className={classes.helperText}
            >
              {getHelperText()}
            </Typography>
          </>
        }
      </div>
    </form>
  )
}

export default SignIn;
